import { render, staticRenderFns } from "./SmsTextUsage.vue?vue&type=template&id=c44c9352&scoped=true"
import script from "./SmsTextUsage.vue?vue&type=script&lang=js"
export * from "./SmsTextUsage.vue?vue&type=script&lang=js"
import style0 from "./SmsTextUsage.vue?vue&type=style&index=0&id=c44c9352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44c9352",
  null
  
)

export default component.exports